module.exports = __webpack_public_path__ + "img/7.28b7d288.png";